export default function About() {
  return (
    <div id="about" className="about-us section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div
              className="left-image wow fadeIn text-white"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              <h2 className="">Why Attend?</h2>
              <h3>ACTnet Global Kick-Off Conference 2026</h3>
              {/* <img src="assets/images/man-standing.png" alt="person graphic" /> */}
            </div>
          </div>
          <div className="col-lg-8 align-self-center">
            <div className="services">
              <div className="row">
                <div className="col-lg-6">
                  <div
                    className="item wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.5s"
                  >
                    <div className="icon">
                      <img src="assets/images/check.png" alt="" />
                      {/* <img src={require("./../assets/img/check.png")} alt="" /> */}
                    </div>
                    <div className="right-text">
                      <h4>Be recognised as a founding member of ACTnet</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    className="item wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.7s"
                  >
                    <div className="icon">
                      <img src="assets/images/check.png" alt="" />
                    </div>
                    <div className="right-text">
                      <h4>Gain first-mover advantage across sub-networks</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    className="item wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.9s"
                  >
                    <div className="icon">
                      <img src="assets/images/check.png" alt="" />
                    </div>
                    <div className="right-text">
                      <h4>
                        Build partnerships rooted in transparency and speed
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    className="item wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="1.1s"
                  >
                    <div className="icon">
                      <img src="assets/images/check.png" alt="" />
                    </div>
                    <div className="right-text">
                      <h4>
                        Access tools powered by Agile Beyond’s Ops Support
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
